<template>
  <div id="app">
    <Header @showM="showM" @changePage="changePage"></Header>
    <div class="header__main-nav-mobile" v-show="showDropMobile">
      <ul class="header__main-nav-ul">
        <li class="header__main-nav-li" v-for="(item, index) in headerBottomLeftMenusMobile" :key="index" :class="item.showDownArrow ? '--sub' :  ''" @click.stop="showChildrenMobile(item)">
          <!-- <router-link to="/" class="header__main-nav-a ">{{ $t('i18n.headerMain.' + item.name) }}</router-link> -->
          <div class="header__main-nav-a " @click="changePage(index)">
            {{ $t('i18n.headerMain.' + item.name) }}
          </div>
          <div class="header__submenu" v-show="item.children">
            <div class="header__submenu-overflow" v-show="item.showDropDown">
              <div class="header__submenu-wrapper">
                <ul class="header__submenu-list --only-mobile">
                  <li v-for="(child, index) in item.children" :key="index" @click.stop="(e) => showChildren(e, child, index, item)">
                    <span class="header__main-drop-down-div">{{ $t('i18n.headerMainChildren.' + child.name) }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <div class="header__content ml-auto js-links header__links-mobile">
        <ul class="header__content">
          <li class="header__content-li" v-for="(item, index) in $t('i18n.headerTopLeftMenus')" :key="index">
            <span class="header__content-a " @click="toPage(item.path, item)">{{ item.name }}</span>
          </li>
        </ul>
      </div>

      <div class="header__content js-lang header__lang-mobile">
        <drop-down v-cloak class="--country mr-3" @showDrop="showDrop">
          <template v-slot:dropdown__wrapper>
            <div class="dropdown__wrapper">
              <input type="text" class="search-string"/>
              <span class="dropdown__current">{{ selectedRegion }}</span>
            </div>
          </template>
          <!-- 使用 "header" 插槽 -->
          <template v-slot:drop-down-item>
            <drop-down-item  class="dropdown__list" style="display: none;" v-show="showDropF">
              <template v-slot:li>
                <li v-for="(region, code) in $t('i18n.regions')" :key="code" @click="changeRegion(region)">
                  <span>{{ region }}</span>
                </li>
              </template>
            </drop-down-item>
          </template>
        </drop-down>
      </div>
    </div>
    <router-view :key="routerKey" />
    <Footer></Footer>
  </div>
</template>

<script>
import DropDown from "./components/DropDown";
import Footer from "./components/Footer";
import DropDownItem from "./components/DropDownItem";
export default {
  name: 'App',
  components: {Footer, DropDown, DropDownItem},
  data() {
    return {
      currentLang: 'zh',
      selectedRegion: "中文",
      showDropF: false,
      showSearch: false,
      showDropMobile: false,
      headerBottomLeftMenusMobile: [
        {
          name: "news",
          path: "News",
          showDownArrow: false,
          showDropDown: false,
        },
        {
          name: "vacuumValve",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "vacuumValve",
              path: "VacuumValveMain",
              isLast: true,
              showChild: false,
            },
            {
              name: "MGVAGV",
              path: "VacuumValve1",
              isLast: true,
              showChild: false,
              pathImg: require('./assets/imgs/MGVAGV-p.png'),
              img: require('./assets/imgs/MGVAGVimg.png'),
              technicalImg: require('./assets/imgs/MGVAGVTechnical.png'),
              downloadImg: require('./assets/imgs/MGVAGVDownloadImg.png'),
              propertiesName: "MGVAGVpro",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "butterflyValve",
              path: "VacuumValve2",
              isLast: true,
              showChild: false,
              pathImg: require('./assets/imgs/butterfly-p.png'),
              img: require('./assets/imgs/butterflyImg.png'),
              technicalImg: require('./assets/imgs/butterflyTechnical.png'),
              downloadImg: require('./assets/imgs/butterfluDownloadImg.png'),
              propertiesName: "butterflyPro",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "highVacuumDirectValve",
              path: "VacuumValve3",
              isLast: true,
              pathImg: require('./assets/imgs/corner-p.png'),
              img: require('./assets/imgs/corenrImgTwo.png'),
              technicalImg: require('./assets/imgs/corenrTechnicalOne.png'),
              downloadImg: require('./assets/imgs/corenrDownloadOne.png'),
              propertiesName: "highVacuumDirectValve",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "UHV",
              path: "VacuumValve4",
              isLast: true,
              pathImg: require('./assets/imgs/corner-p.png'),
              img: require('./assets/imgs/corenrImg.png'),
              technicalImg: require('./assets/imgs/corenrTechnicalTwo.png'),
              downloadImg: require('./assets/imgs/corenrDownloadTwo.png'),
              propertiesName: "UHV",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "rectangularValve",
              path: "VacuumValve5",
              showChild: false,
              isLast: true,

              pathImg: require('./assets/imgs/rectangularValve-p.png'),
              img: require('./assets/imgs/rectangularValveImg.png'),
              technicalImg: require('./assets/imgs/rectangularValveTechnical.png'),
              downloadImg: require('./assets/imgs/rectangularValveDownload.png'),
              propertiesName: "rectangularValve",
              showFlg: false,
              type: "PDF",
              size: "4 MB"
            },{
              name: "highVacuumGateValve",
              path: "VacuumValve6",
              isLast: true,

              pathImg: require('./assets/imgs/higVacuum-p.png'),
              img: require('./assets/imgs/highVacuumImg.png'),
              technicalImg: require('./assets/imgs/highVacuumTechnical.png'),
              downloadImg: require('./assets/imgs/highVacuumDownload.png'),
              propertiesName: "highVacuumGateValve",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "vacuumGateValve",
              path: "VacuumValve7",
              isLast: true,

              pathImg: require('./assets/imgs/higVacuum-p.png'),
              img: require('./assets/imgs/vacuumImg.png'),
              technicalImg: require('./assets/imgs/vacuumTechnical.png'),
              downloadImg: require('./assets/imgs/vacuumDownload.png'),
              propertiesName: "vacuumGateValve",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
            {
              name: "combinedValve",
              path: "VacuumValve8",
              isLast: false,
              pathImg: require('./assets/imgs/combinedValbe-p.png'),
              img: require('./assets/imgs/combinedValveImg.png'),
              technicalImg: require('./assets/imgs/combinedValveTechnical.png'),
              downloadImg: require('./assets/imgs/combinedValveDownload.png'),
              propertiesName: "combinedValve",
              showFlg: true,
              type: "PDF",
              size: "4 MB"
            },
          ],
          path: "VacuumValveMain",
        },
        {
          name: "presys",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "presys",
              path: "Presys",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "presysBriefIntroduction",
              path: "PresysBriefIntroduction",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "presysCourse",
              path: "PresysProcess",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
          ],
        },
        {
          name: "productService",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "valveRepairDndMaintenance",
              path: "valveRepairDndMaintenance",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "upgradeDndTransformation",
              path: "upgradeDndTransformation",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "serviceCenter",
              path: "serviceCenter",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
          ],
        },
        {
          name: "otherProducts",
          showDownArrow: true,
          showDropDown: false,
          children: [
            {
              name: "throttleValve",
              path: "throttleValve",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "throttleValveController",
              path: "throttleValveController",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "dualThrottleValve",
              path: "dualThrottleValve",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "multiPositionController",
              path: "multiPositionController",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "MNE",
              path: "MNE",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
            {
              name: "UNISEMChiller",
              path: "UNISEMChiller",
              isLast: true,
              showChild: false,
              showFlg: true,
            },
          ],
        },
      ],
    }
  },
  computed: {
    routerKey () {
      return this.$route.path + new Date();
    }
  },  
  mounted() {
    // this.currentIndex = sessionStorage.getItem("pagePath") || 1;
    this.currentLang = sessionStorage.getItem("language") || 'zh';
    if (this.currentLang == 'zh') {
      this.$store.commit('saveLanguage', '中文')
      this.$i18n.locale = "zh";
    } else {
      this.$i18n.locale = "en";
      this.$store.commit('saveLanguage', 'English')
    }
  },
  methods: {
    showDropDown(e, item, index) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      this.$router.push({
        name: item.path,
      })
    },
    showChildren(e, item, index, father) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      if (father.name === "vacuumValve") {
        if (item.path) {
          let temp = father.children;
          let params = [];
          temp.forEach(t => {
            let data = Object.assign({}, t);
            if (t.name === item.name) {
              data.isShow = true;
              data.pathName = this.$t('i18n.headerMain.' + father.name)
              data.lastPathName = this.$t('i18n.headerMainChildren.' + item.name)
            }
            params.push(data);
          });

          father.showDropDown = false;
          this.$router.push({
            name: item.path,
            params: { list: params }
          })
        }
      } else {
        father.showDropDown = false;
        this.$router.push(item.path)
      }
      this.showDropMobile = false;
    },
    handleClick(item, father) {
      if ("/" + item.path === this.$route.path) {
        return;
      }
      let params = [];
      let data = Object.assign({}, father);
      data.children.forEach(f => {
        if (f.children) {
          f.children.forEach(t => {
            if (t.name === item.name) {
              t.isShow = true;
              t.pathName = this.$t('i18n.headerMain.' + father.name)
              t.lastPathName = this.$t('i18n.headerMainChildren.' + item.name)
            }
          });
        }
      });
      params = data.children;

      father.showDropDown = false;
      this.$router.push({
        name: item.path,
        params: { list: params }
      })
    },
    toPage(path, item) {
      if (path) {
        this.$router.push(path)
      }
      if (item) {
        this.showDropMobile = false;
      }
    },
    showDrop() {
      this.showDropF = !this.showDropF;
    },
    changeRegion(region) {
      sessionStorage.setItem("language", region === "中文" ? 'zh' : 'en');
      this.$store.commit('saveLanguage', region)
      this.$i18n.locale = region === "中文" ? 'zh' : 'en';
      this.$router.go(0);
    },
    showChildrenMobile(item) {
      item.showDropDown = !item.showDropDown
    },
    showM() {
      this.showDropMobile = !this.showDropMobile
    },
    changePage (index) {
      if(index !== 0) return 
      this.showDropMobile = !this.showDropMobile
      this.$router.push({
        name: 'News'
      })
    }
  },
}
</script>

<style>
.white-box__link:hover {
  background: #990099 !important;
}

.white-box__link:hover .white-box__link-label {
  color: #ffffff !important;
}

.white-box__link:hover .white-box__link-text {
  color: #ffffff !important;
}

.va-btn {
  transition: .3s;
}

.va-btn:hover {
  background: #990099 !important;
  color: #FFF !important;
}
@media (max-width: 1279.9px) {
  #app {
    padding-top: 11rem !important;
    max-width: 100vw;
  }

}

@media (max-width: 1279.9px) {
  .header__main-nav-li.--sub .header__main-nav-a:after {
    width: 3rem;
    height: 3rem;
    top: 2rem;
  }
  .header__logo {
    width: 15rem;
    min-width: 9.4rem;
    height: 3.1rem;
    margin-right: 3rem;
    margin-top: 4rem;
  }
  .header__wrapper {
    padding: 0 3rem;
  }
  .header__search-loupe {
    margin-left: 1.2rem;
    margin-right: 3rem;
  }
  .header__main-nav-li:before {
    left: 1.5rem;
    right: 1.5rem;
  }
}

@media (max-width: 1024px) {
  .header__submenu-list.--only-mobile {
    display: block;
  }
  .header__searchbar {
    top: 12rem;
    margin-top: 0;
    border-top: .1rem solid #ededed;
    left: 0;
    right: 0;
    padding: 3rem;
    background: #fff;
    height: auto;
  }
  .header__searchbar-wrapper {
    position: relative;
  }
  .header__hamburger {
    display: flex;
  }
  .header__wrapper {
    height: 7rem;
    padding: 0 1.5rem 0 3rem;
  }
  .header__main-nav {
    display: none;
  }
  .header__top-wrapper {
    display: none !important;
  }
  .header__search {
    margin-left: auto;
    display: flex;
    margin-top: 5rem;
  }
  .header__search-loupe {
    width: 5rem;
    height: 5rem;
  }
}
#app {
  min-height: 100vh;
  width: 100vw;
  padding-top: 15rem;
  overflow-x: hidden;
}
:focus {
  outline: none;
}
body {
  color: #4c4c4c;
  font-size: 2rem;
  line-height: 3rem;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  letter-spacing: -.02rem;
  overflow-x: hidden;
  text-size-adjust: none !important;
  -moz-text-size-adjust: none !important;
  -webkit-text-size-adjust: none !important;
  -webkit-font-smoothing: antialiased;
}
main {
  display: block;
  unicode-bidi: isolate;
}


.header__main-nav-mobile {
  position: fixed;
  z-index: 99999;
  left: 0;
  width: 100%;
  height: calc(100% - 11rem);
  overflow: auto;
  background: #fff;
}
.header__main-nav-mobile .header__main-nav-ul {
  display: block;
  height: auto;
  width: 100%;
  padding: 1rem 0;
  background: #fafafa;
}

.header__submenu-overflow {
  overflow: auto;
  max-height: calc(100vh - 15rem);
  background: #fff;
}
.header__submenu-wrapper {
  border: 0;
  height: auto;
  padding: 1rem 0;
  max-height: 100%;
  overflow: visible;
}
.header__submenu-list.--only-mobile {
  display: none;
  padding: 0 3rem;
}
.header__main-nav-mobile .header__main-nav-a {
  font-size: 2rem;
  height: 6rem;
  padding: 1rem 3rem !important;
  min-height: 4rem;
  margin: 0;
}
.header__submenu-list.--only-mobile .header__main-drop-down-div {
  font-size: 2rem;
  padding: 1rem 3rem !important;
  height: 4rem;
  display: block;
}
.header__submenu-list.--only-mobile .header__main-drop-down-div:after {
  content: "";
  width: 1rem;
  height: 1rem;
  background: url(./assets/imgs/select-arrow.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  margin-top: -0.3rem;
}
.header__links-mobile {
  padding: 0 3rem 1.5rem;
  background: #fafafa;
}
.header__links-mobile .header__content {
  padding-top: 3rem;
  border-top: .1rem solid #e6e6e6;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.header__links-mobile .header__content .header__content-li {
  min-width: 50%;
  max-width: 50%;
  margin: 0 0 1.5rem;
}
.header__lang-mobile {
  background: #fff;
  padding: 3rem;
  display: flex;
  justify-content: center;
}


.header__content {
  display: flex;
}
.dropdown__list {
  width: 100%;
  min-width: 17rem;
  max-height: 17rem;
  min-height: 4rem;
  overflow: auto;
  background: #fff;
  position: absolute;
  border: .1rem solid #e6e6e6;
  top: 100%;
  margin-top: .2rem;
  z-index: 200;
  border-radius: .4rem;
  box-shadow: 0 2rem 4rem 0 rgba(0,0,0,.1);
}
.dropdown__list::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  border-radius: 0.4rem;
}
.dropdown__list ul li span {
  cursor: pointer;
}
.dropdown__list ul li a, .dropdown__list ul li span {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}

.header__content {
  display: flex;
}
ol, ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.header__content-li {
  margin: 0 2rem;
  display: flex;
  align-items: center;
}

.header__wrapper {
  height: 10rem;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  position: relative;
}

.header__logo {
  width: 12.72rem;
  min-width: 12.72rem;
  height: 4.2rem;
  margin-right: 4rem;
  background: url(./assets/imgs/logo.png) no-repeat 50%;
  background-size: 100% auto;
}
a {
  text-decoration: none;
  transition-property: all;
  transition-duration: .3s;
}

.header__main-nav {
  margin-left: auto;
  height: 100%;
}

.header__main-nav-ul {
  display: flex;
  height: 100%;
}

.header__main-nav-li {
  position: relative;
  height: 100%;
}

.header__main-nav-a {
  font-size: 1.8rem;
  color: #000;
  letter-spacing: -.018rem;
  line-height: 3rem;
  padding: 0 3rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 100%;
}

.header__main-nav-li.--sub .header__main-nav-a:after {
  content: "";
  width: 0.8rem;
  height: 0.6rem;
  background: url(./assets/imgs/downArrowTow.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  top: 50%;
  margin-top: -0.3rem;
}

.header__main-nav-li.--search .header__main-nav-a:after {
  content: "";
  width: 3.5rem;
  height: 3.5rem;
  background: url(./assets/imgs/searchImg.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  top: 35%;
  margin-top: -0.3rem;
}
.header__main-nav-a {
  cursor: pointer;
}

.dropdown .dropdown__wrapper:before {
  background: #80ba27;
}
.dropdown .dropdown__wrapper:before {
  content: "";
  width: 1.6rem;
  height: 1.6rem;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -.8rem;
  background: #ccc;
  -webkit-mask: url(./assets/imgs/world.svg) no-repeat center;
  mask: url(./assets/imgs/world.svg) no-repeat center;
  transition: all .2s ease-in-out;
}
.dropdown .dropdown__wrapper:after, .dropdown.--visible.--text .dropdown__wrapper:after {
  right: 0;
}
.dropdown .dropdown__wrapper:after {
  background: lightgray;
}
.dropdown__wrapper:after {
  content: "";
  width: .8rem;
  height: .6rem;
  -webkit-mask: url(./assets/imgs/downArrow.png) no-repeat center;
  mask: url(./assets/imgs/downArrow.png) no-repeat center;
  position: absolute;
  right: 2rem;
  top: 50%;
  margin-top: -.3rem;
  transition-property: background;
  transition-duration: .3s;
}
.header__main-drop-down {
  display: none;
}
.header__main-nav-li.--hover .header__main-drop-down {
  display: block !important;
  width: 25rem;
  min-width: 17rem;
  max-height: 26rem;
  min-height: 6rem;
  overflow: auto;
  background: #fff;
  position: absolute;
  border: .1rem solid #e6e6e6;
  top: 100%;
  /*margin-top: .2rem;*/
  z-index: 200;
  border-radius: .4rem;
  box-shadow: 0 2rem 4rem 0 rgba(0,0,0,.1);

}
.header__main-nav-li.--hover .header__main-drop-down::-webkit-scrollbar-thumb {
  background: #e6e6e6;
  -webkit-transition: all .2s ease-in-out;
  transition: all .2s ease-in-out;
  border-radius: 0.4rem;
}
.header__main-nav-li.--hover .header__main-drop-down .header__main-drop-down-span {
  cursor: pointer;
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}
.header__main-nav-li.--hover .header__main-drop-down-span {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.6rem;
  line-height: 1.8rem;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son {
  width: 100%;
  min-height: 4rem;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.2rem;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son .header__main-drop-down-span-son-span {
  cursor: pointer;
  width: 100%;
  min-height: 4rem;
  display: flex;
  align-items: center;
  color: #4c4c4c;
  font-size: 1.2rem;
  line-height: 1rem;
}

.header__main-nav-li.--hover .header__main-drop-down-span.--down:after {
  transform: rotate(90deg);
}
.header__main-nav-li.--hover .header__main-drop-down-span:after {
  content: "";
  width: 1rem;
  height: 1rem;
  -webkit-mask: url(./assets/imgs/arrow-right.png) no-repeat center;
  mask: url(./assets/imgs/arrow-right.png) no-repeat center;
  position: absolute;
  right: 2rem;
  margin-top: -.3rem;
  background-color: #66207F;
  transition-property: background;
  transition-duration: .3s;
}
.header__main-nav-li.--hover .header__main-drop-down-span:hover {
  color: #66207F;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son-span:hover {
  color: #66207F;
}
.header__main-nav-li.--hover .header__main-drop-down-span-son-span:after {
  content: "";
  width: 1rem;
  height: 1rem;
  -webkit-mask: url(./assets/imgs/arrow-right.png) no-repeat center;
  mask: url(./assets/imgs/arrow-right.png) no-repeat center;
  position: absolute;
  right: 2rem;
  margin-top: -.3rem;
  background-color: #66207F;
  transition-property: background;
  transition-duration: .3s;
}

.header__search-loupe {
  margin-left: 2.4rem;
  width: 3.8rem;
  height: 3.8rem;
  cursor: pointer;
  background: #66207F;
  -webkit-mask: url(./assets/imgs/searchImg.png) no-repeat center;
  mask: url(./assets/imgs/searchImg.png) no-repeat center;
  transition-property: background-color;
  transition-duration: .3s;
}
.header__hamburger {
  width: 6rem;
  height: 6rem;
  cursor: pointer;
  display: none;
  -webkit-mask: url(./assets/imgs/hamburger.svg) no-repeat center;
  mask: url(./assets/imgs/hamburger.svg) no-repeat center;
  background-color: #5A246B;
}
.header__searchbar {
  position: absolute;
  left: 21.5rem;
  right: 21.5rem;
  top: 50%;
  margin-top: -3.5rem;
  height: 7rem;
}
.header__search-btn {
  width: 6.6rem;
  height: 7rem;
  cursor: pointer;
  position: absolute;
  right: 2.5rem;
  top: 0;
  padding: 0;
  background: #b2b2b2;
  -webkit-mask: url(./assets/imgs/searchImg.png) no-repeat center;
  mask: url(./assets/imgs/searchImg.png) no-repeat center;
  border: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition: all .2s ease-in-out;
}
.form-input, input[type=email], input[type=text] {
  width: 100%;
  height: 6rem;
  padding: 0 2.5rem;
  font-size: 1.3rem;
  font-weight: 500;
  color: #000;
  font-family: Calibre, Helvetica, Tahoma, Arial, sans-serif;
  border: .1rem solid #e6e6e6;
  border-radius: .4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  transition-property: all;
  transition-duration: .3s;
}
.header__searchbar-input {
  width: 100%;
  height: 7rem!important;
  padding: 0 3rem;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  font-size: 1.8rem;
  color: #4c4c4c;
  letter-spacing: 0;
  border-radius: .4rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
.header__search-loupe.--close {
  mask: url(./assets/imgs/close.svg) no-repeat center;
}


.header__main-nav-mobile {
  position: fixed;
  z-index: 99999;
  left: 0;
  width: 100%;
  height: calc(100% - 11rem);
  overflow: auto;
  background: #fff;
}
.header__main-nav-mobile .header__main-nav-ul {
  display: block;
  height: auto;
  width: 100%;
  padding: 1rem 0;
  background: #fafafa;
}

.header__submenu-overflow {
  overflow: auto;
  max-height: calc(100vh - 15rem);
  background: #fff;
}
.header__submenu-wrapper {
  border: 0;
  height: auto;
  padding: 1rem 0;
  max-height: 100%;
  overflow: visible;
}
.header__submenu-list.--only-mobile {
  display: none;
  padding: 0 3rem;
}
.header__main-nav-mobile .header__main-nav-a {
  font-size: 2rem;
  height: 6rem;
  padding: 1rem 3rem !important;
  min-height: 4rem;
  margin: 0;
}
.header__submenu-list.--only-mobile .header__main-drop-down-div {
  font-size: 2rem;
  padding: 1rem 3rem !important;
  height: 4rem;
  display: block;
}
.header__submenu-list.--only-mobile .header__main-drop-down-div:after {
  content: "";
  width: 1rem;
  height: 1rem;
  background: url(./assets/imgs/select-arrow.png) no-repeat 50%;
  position: absolute;
  right: 1.5rem;
  margin-top: -0.3rem;
}
.header__links-mobile {
  padding: 0 3rem 1.5rem;
  background: #fafafa;
}
.header__links-mobile .header__content {
  padding-top: 3rem;
  border-top: .1rem solid #e6e6e6;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
.header__links-mobile .header__content .header__content-li {
  min-width: 50%;
  max-width: 50%;
  margin: 0 0 1.5rem;
}
.header__lang-mobile {
  background: #fff;
  padding: 3rem;
  display: flex;
  justify-content: center;
}



@media (max-width: 1279.9px) {
  .header__main-nav-li.--sub .header__main-nav-a:after {
    width: 3rem;
    height: 3rem;
    top: 2rem;
  }
  .header__logo {
    width: 15rem;
    min-width: 9.4rem;
    height: 3.1rem;
    margin-right: 3rem;
    margin-top: 4rem;
  }
  .header__wrapper {
    padding: 0 3rem;
  }
  .header__search-loupe {
    margin-left: 1.2rem;
    margin-right: 3rem;
  }
  .header__main-nav-li:before {
    left: 1.5rem;
    right: 1.5rem;
  }
}

@media (max-width: 1024px) {
  .header__submenu-list.--only-mobile {
    display: block;
  }
  .header__searchbar {
    top: 12rem;
    margin-top: 0;
    border-top: .1rem solid #ededed;
    left: 0;
    right: 0;
    padding: 3rem;
    background: #fff;
    height: auto;
  }
  .header__searchbar-wrapper {
    position: relative;
  }
  .header__hamburger {
    display: flex;
  }
  .header__wrapper {
    height: 11rem;
    padding: 0 1.5rem 0 3rem;
  }
  .header__main-nav {
    display: none;
  }
  .header__top-wrapper {
    display: none !important;
  }
  .header__search {
    margin-left: auto;
    display: flex;
    margin-top: 5rem;
  }
  .header__search-loupe {
    width: 5rem;
    height: 5rem;
  }
}

@media (max-wdith: 768px) {
  #app {
    padding-top: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue